import { DatePicker } from 'antd';
import moment from 'moment';
import React, { useEffect, useRef } from 'react';

const WrappedDatePicker = ({ children, format, onBlur, onChange, ...otherProps }) => {
  // useRef используем для хранения значений между рендерами
  const hash = useRef(null);

  const curInput = useRef('');
  // чтобы функция не вызывалась
  if (hash.current === null) {
    hash.current = crypto.randomUUID();
  }

  useEffect(() => {
    const listener = (e) => {
      curInput.current = e.target.value;
    };

    document.getElementById(hash.current).addEventListener('input', listener);

    return () => {
      document.getElementById(hash.current) &&
        document.getElementById(hash.current).removeEventListener('input', listener);
    };
  }, []);

  const onHandleBlur = (e) => {
    moment(curInput.current, format, true).isValid() && onHandleChange(moment(curInput.current, format, true));
    onBlur && onBlur(e);
  };

  const onHandleChange = (val) => {
    curInput.current = '';
    onChange && onChange(val);
  };

  return (
    <DatePicker id={hash.current} format={format} onChange={onHandleChange} onBlur={onHandleBlur} {...otherProps}>
      {children}
    </DatePicker>
  );
};

export default WrappedDatePicker;
